import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { MyAdherences } from '@components/templates/myAccount/myAdherences';

export function MyAdherencesPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('my-adherence-component.metatags.title'),
        description: t('my-adherence-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myAdherences,
        index: false,
    });

    return <MyAdherences />;
}
